import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT } from '../../../../constants';
import { DECLINED_PAYMENT_CODE } from '../../../../services/checkout/constants';

import { getPartner } from '../../../../services/partner/selector';

import {
    getLastUserInfoStored,
    isFailureBankTransferEnabled
} from '../../../../utils/storageUtils';
import { getPartnerIdFromQuery } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import LinkButtonComponent from '../../../button/LinkButtonComponent';
import ErrorEbonPageKycBloc from './kyc/ErrorEbonPageKycBloc';
import ErrorEbonPageBankTransferBloc from './banktransfer/ErrorEbonPageBankTransferBloc';
import ErrorEbonPageStateController from './ErrorEbonPageStateController';

import './ErrorEbonPage.scss';

const ErrorEbonPage = ({
    i18n,
    BRAND_NAME,
    ebcPartnerId,
    paymentId,
    partner,
    status,
    identityVerified,
    identityVerifiedFetching
}) => {
    const [kycErrorCase, setKycErrorCase] = useState(null);

    const userInfo = getLastUserInfoStored();
    const failureBankTransferEnabled = isFailureBankTransferEnabled();

    const kycRequired =
        !identityVerified && (failureBankTransferEnabled || status === DECLINED_PAYMENT_CODE);

    const showBankTransfer = Boolean(
        !identityVerifiedFetching &&
            failureBankTransferEnabled &&
            !kycRequired &&
            paymentId &&
            userInfo &&
            userInfo.phoneNumber
    );
    const showKyc = Boolean(
        !identityVerifiedFetching && kycRequired && userInfo && userInfo.phoneNumber
    );

    return (
        <div className="template template-primary flex-container-v">
            <ErrorEbonPageStateController
                status={status}
                partner={partner}
                failureBankTransferEnabled={failureBankTransferEnabled}
                kycErrorCase={kycErrorCase}
                setKycErrorCase={setKycErrorCase}
            />

            <div className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper steps={i18n.STEPS} current={2} />
                    </header>
                </div>
            </div>

            <main id="p-ebon-error" role="main" className="conteneur conteneur-mobile">
                <HeadComponent
                    title={i18n.ERROR.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.EBON_ERROR_PATH}-${ebcPartnerId}`}
                />
                <Stepper steps={i18n.STEPS} current={2} cssClass="mobileDisplay" />
                <div className="error-container">
                    <h1>{i18n.ERROR.TITLE}</h1>

                    <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_1)}</p>
                    <div className="reasons">
                        <ul>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_2)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_3)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_4)}</li>
                        </ul>
                    </div>
                    <p>{i18n.ERROR.TEXT_5}</p>
                    <p>{i18n.ERROR.TEXT_6}</p>

                    {identityVerifiedFetching ? (
                        <div className="loading" role="status" aria-live="polite">
                            <span className="sr-only">{i18n.ERROR.LOADING_LABEL}</span>
                            <LoadingComponent />
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="conteneur-color">
                                <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_7)}</p>
                                {showKyc && (
                                    <LinkButtonComponent
                                        to={PATH.HOME_PATH}
                                        text={i18n.ERROR.BUTTON_TEXT}
                                        color="main"
                                    />
                                )}
                            </div>

                            {(showBankTransfer || showKyc) && <p>{i18n.ERROR.TEXT_OR}</p>}

                            <ErrorEbonPageBankTransferBloc
                                show={showBankTransfer}
                                paymentId={paymentId}
                            />

                            <ErrorEbonPageKycBloc show={showKyc} kycErrorCase={kycErrorCase} />

                            {!showKyc && (
                                <LinkButtonComponent
                                    to={PATH.HOME_PATH}
                                    text={i18n.ERROR.BUTTON_TEXT}
                                    color="main"
                                />
                            )}
                        </React.Fragment>
                    )}
                </div>
            </main>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const ebcPartnerId = getPartnerIdFromQuery(ownProps.match.url);
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paymentId = orderId ? params.orderId.replaceAll('-', '').substr(0, 8) : null;
    const status = params.code;

    const partnerId = ownProps.match.params.id;
    const partner = getPartner(state, partnerId);

    return {
        i18n: state.i18n.page.EBON,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        ebcPartnerId: ebcPartnerId,
        paymentId: paymentId,
        partner,
        status,
        identityVerified: state.account.identity.verified,
        identityVerifiedFetching: state.account.identity.fetching
    };
};

export default withRouter(connect(mapStateToProps)(ErrorEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPage.js